import * as quote from "./reducers/quote.reducer";
import * as customer from "./reducers/customer.reducer";
import * as product from "./reducers/product.reducer";
import * as rental from "./reducers/rental.reducer";
import * as purchase from "./reducers/purchase.reducer";
import * as transport from "./reducers/transport.reducer";
import * as floorplanner from "./reducers/floorplanner.reducer";
import * as kwikspace from "./reducers/kwikspace.reducer";

export interface KwikspaceStoreState {
  quote: quote.QuoteState;
  customer: customer.CustomerState;
  product: product.ProductState;
  rental: rental.RentalState;
  purchase: purchase.PurchaseState;
  transport: transport.TransportState;
  floorplanner: floorplanner.FloorPlannerState;
  kwikspace: kwikspace.KwikspaceState;
}

export const reducers = {
  quote: quote.reducer,
  customer: customer.reducer,
  product: product.reducer,
  rental: rental.reducer,
  purchase: purchase.reducer,
  transport: transport.reducer,
  floorplanner: floorplanner.reducer,
  kwikspace: kwikspace.reducer
};
